'use client';

import * as React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider, createConfig } from 'wagmi';
import { base, baseSepolia } from 'wagmi/chains';
import { http, type Chain } from 'viem';
import { RainbowKitProvider } from '@rainbow-me/rainbowkit';
import { farcasterMiniApp } from '@farcaster/miniapp-wagmi-connector';

const chainId = process.env.NEXT_PUBLIC_CHAIN_ID
  ? Number(process.env.NEXT_PUBLIC_CHAIN_ID)
  : null;

const chains: readonly [Chain, ...Chain[]] = chainId === 84532
  ? [baseSepolia] as const
  : [base] as const;

const queryClient = new QueryClient();

export function MiniAppWeb3Providers({ children }: { children: React.ReactNode }) {
  const config = React.useMemo(() => {
    const isBrowser = typeof window !== 'undefined';

    return createConfig({
      connectors: isBrowser ? [farcasterMiniApp()] : [],
      chains,
      transports: {
        [base.id]: http(),
        [baseSepolia.id]: http(),
      },
      ssr: true,
    });
  }, []);

  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>{children}</RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}
